import { Map } from 'immutable';

import { aiGenerated, aiGeneratedV2 } from './ai';
import { isFeatureEnabled } from '../../../featureFlags';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { FEATURES } from '../../../../constants/billing';
import { VALUE } from '../../../../constants/product';
import ATTRIBUTE from '../../../../constants/attributes';

export function title({ channel, operation, preview, state, userId }) {
  switch (operation) {
    case OPERATIONS[channel].TITLE.AI_GENERATED: {
      return isFeatureEnabled({ feature: FEATURES.AI_V2, userId })
        ? aiGeneratedV2({ attribute: ATTRIBUTE.TITLE, channel, preview, state })
        : aiGenerated({ attribute: ATTRIBUTE.TITLE, operation: OPERATIONS[channel].TITLE.SET, preview, state });
    }

    case OPERATIONS[channel].TITLE.FIND_AND_REPLACE: {
      return {
        payload: Map({
          type: operation,
          value: Map({
            find: preview.getIn([ATTRIBUTE.TITLE, FIND]),
            replace: preview.getIn([ATTRIBUTE.TITLE, REPLACE]),
          }),
        }),
      };
    }

    default: {
      return {
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.TITLE, VALUE]),
        }),
      };
    }
  }
}
